(() => {
  document.querySelectorAll('[data-eysn-root]').forEach((root) => {
    if (root.dataset.eysnReady === 'true') return;
    root.dataset.eysnReady = 'true';
    const items=[...root.querySelectorAll('[data-eysn-item]')];
    const closeAll=(except)=>{
      items.forEach((item)=>{
        if(item!==except){item.classList.remove('is-open');item.querySelector('[data-eysn-trigger]')?.setAttribute('aria-expanded','false')}
      });
    };
    items.forEach((item)=>{
      const trigger=item.querySelector('[data-eysn-trigger]');
      if(!trigger)return;
      trigger.addEventListener('click',(e)=>{
        e.preventDefault();
        const open=!item.classList.contains('is-open');
        closeAll();
        if(open){item.classList.add('is-open');trigger.setAttribute('aria-expanded','true')}
      });
      if(root.dataset.openMode==='hover_click'){
        item.addEventListener('mouseenter',()=>{closeAll(item);item.classList.add('is-open');trigger.setAttribute('aria-expanded','true')});
        item.addEventListener('mouseleave',()=>{item.classList.remove('is-open');trigger.setAttribute('aria-expanded','false')});
      }
    });
    document.addEventListener('click',(e)=>{if(!root.contains(e.target))closeAll()});
    document.addEventListener('keydown',(e)=>{if(e.key==='Escape')closeAll()});
  });
})();